import {
    Container,
    Sprite,
} from 'pixi.js';
import { LoadContext } from '../../utils';

const PADDING_Y = 26;
const PADDING_X = 9;
const COLUMN_PADDING = 46;
const SINGLE_SPACING = 9;
const SINGLE_OFFSET = 11;
const MAX_ROWS = 6;
const COLUMN_BREAK = 2;
const MAX_COLUMNS = 4;

export class Tally extends Container
{
    public total: number;

    public static preload()
    {
        const loader = LoadContext.current;
        loader.add('ResultAtlas', './assets/result/ResultAtlas{size}.json');
    }

    constructor(count:number)
    {
        super();
        this.total = count;

        const loader = LoadContext.current;
        const singleTex = loader.getTexture('tally', 'ResultAtlas');
        const fiveTex = loader.getTexture('tally_5', 'ResultAtlas');
        const tenCircle = loader.getTexture('tens', 'ResultAtlas');

        let column = 0;
        let row = 0;
        let startX = 0;
        let startY = 0;
        while (count > 0)
        {
            if (count >= 5)
            {
                const tally = new Sprite(fiveTex);
                tally.position.set(startX, startY);
                this.addChild(tally);
                /* attempt to fill in the order of (shortened MAX_ROWS for example):
                0 1 6 7
                2 3 8 9
                4 5 10 11
                */
                let makeCircle = false;
                if (++column == COLUMN_BREAK)
                {
                    makeCircle = true;
                    // if here, need to go down a row on our left section
                    if (++row >= MAX_ROWS)
                    {
                        // if here, need to go back to the top into the right section
                        row = 0;
                        startX = (fiveTex.width) * COLUMN_BREAK + PADDING_X + COLUMN_PADDING;
                        startY = 0;
                    }
                    else
                    {
                        // otherwise, hop down a row, go to left side
                        column = 0;
                        startX = 0;
                        startY += fiveTex.height + PADDING_Y;
                    }
                }
                else if (column >= MAX_COLUMNS)
                {
                    // if here, need to go down a row in our right section
                    if (++row >= MAX_ROWS)
                    {
                        // if here, we ran out of space
                        throw new Error(`Couldn't create enough tallies for ${this.total}`);
                    }
                    else
                    {
                        makeCircle = true;
                        // otherwise, hop down a row, go to left (of our right side)
                        column = COLUMN_BREAK;
                        startX = (fiveTex.width) * COLUMN_BREAK + PADDING_X + COLUMN_PADDING;
                        startY += fiveTex.height + PADDING_Y;
                    }
                }
                else
                {
                    startX += fiveTex.width + PADDING_X;
                }
                count -= 5;
                if (makeCircle)
                {
                    const circle = new Sprite(tenCircle);
                    circle.x = tally.x - tally.width - PADDING_X - 20;
                    circle.y = tally.y - 12;
                    this.addChild(circle);
                }
            }
            else
            {
                startX += SINGLE_OFFSET;
                for (let i = 0; i < count; ++i)
                {
                    const tally = new Sprite(singleTex);
                    tally.position.set(startX, startY);
                    this.addChild(tally);

                    startX += singleTex.width + SINGLE_SPACING;
                }
                // bail out regardless
                break;
            }
        }
    }

    public destroy()
    {
        super.destroy({children: true});
    }
}